import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::ErrorInternalRoute @model={{@model}} />",{ moduleName: "mewe/templates/error-500.hbs" })